var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warm-prompt PayWarmPrompt"},[_vm._v("\n  温馨提示： 网站设置防盗刷系统，请合理使用海量下载账号。如用户短时间内高频或大量下载可能触发该系统，将暂时暂停账号下载功能，如有疑问\n  "),_c('a',{staticClass:"icon-kefu-box",attrs:{"href":_vm.PAGE_LINK.SERVICE,"target":"_blank"}},[_c('i',{staticClass:"iconfont icon-kefu"}),_vm._v("在线客服\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }